/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { GameTagEnumType } from './GameTagEnum'
import { RootStoreType } from './index'

/**
 * GameStateBase
 * auto generated base class for the model GameStateModel.
 */
export const GameStateModelBase = ModelBase.named('GameState')
  .props({
    __typename: types.optional(types.literal('GameState'), 'GameState'),
    description: types.union(types.undefined, types.string),
    tag: types.union(types.undefined, GameTagEnumType)
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class GameStateModelSelector extends QueryBuilder {
  get description() {
    return this.__attr('description')
  }
  get tag() {
    return this.__attr('tag')
  }
}
export function selectFromGameState() {
  return new GameStateModelSelector()
}

export const gameStateModelPrimitives = selectFromGameState().description.tag
